import { useExchangeSetting } from 'app/hooks/trade/exchangeSetting'
import React from 'react'
import { Text } from 'styles/reactnative'
import { COLORS } from '../../constants'
import BigNumber from 'bignumber.js'

const RealizeDpl = ({ data }) => {
	const { data: EP } = useExchangeSetting(data?.exchange_pairs_id)
	return (
		<Text
			style={{
				justifyContent: 'flex-end',
				color:
					data?.pnl_price > 0
						? COLORS.lightGreen
						: data?.pnl_price === 0
						? 'black'
						: COLORS.lightRed,
			}}>
			{BigNumber(data?.pnl_price).toFormat(0)}원
		</Text>
	)
}

export default RealizeDpl
